import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const ModalBody = styled.div`
  padding: 15px;
`

export const ModalFooter = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: space-around;
  align-self: center;
  align-items: center;
  margin-top: 10px;
  border-top: 1px solid #C4C4C4;
`

export const ButtonOK = styled(ButtonMui)`
  width: 100%;
  height: 34px;
  text-transform: none !important;
  border-radius: 10px !important;
  font-size: 16px !important;
`

export const ButtonCancel = styled(ButtonMui)`
  width: 200px;
  height: 34px;
  text-transform: none !important;
  border-radius: 10px !important;
  font-size: 16px !important;
`

export const ButtonContinue = styled(ButtonMui)`
  width: 200px;
  height: 34px;
  text-transform: none !important;
  border-radius: 10px !important;
  font-size: 16px !important;
`

export const TextInfo = styled.span`
  font-size: 17px;
`

export const InvoiceList = styled.ul<{ maxHeight: string }>`
  list-style-type: disc;
  padding-left: 1.5rem;
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: auto;
`

export const InvoiceItem = styled.li`
  font-size: 16px;
  font-weight: bold;
`
